module.exports = __webpack_public_path__ + "static/media/2_payment@2x.10479f5d.jpg";